import React, { useEffect, useState } from "react";
import { useApp } from "@/context/AppContext";
import api from "@/lib/api";
import { PageHeader } from "@/components/common/Common";
import { Building2, Mail, Phone, MapPin, Globe } from "lucide-react";

export default function OrganizationPage() {
  const { t } = useApp();
  const [org, setOrg] = useState(null);
  useEffect(() => { api.get("/organization").then((r) => setOrg(r.data)).catch(() => {}); }, []);
  if (!org) return <div className="h-40 bg-muted rounded-md animate-pulse" />;

  const rows = [
    { icon: Mail, label: t("email"), value: org.email },
    { icon: Phone, label: t("phone"), value: org.phone },
    { icon: MapPin, label: t("address"), value: org.address },
    { icon: Globe, label: "Timezone", value: org.timezone },
  ];
  return (
    <div>
      <PageHeader title={t("orgProfile")} subtitle="Organization details" />
      <div className="bg-card border border-border rounded-md overflow-hidden max-w-2xl">
        <div className="bg-[hsl(var(--sidebar))] text-white p-6 flex items-center gap-4">
          <div className="h-16 w-16 rounded-md bg-primary flex items-center justify-center"><Building2 className="h-8 w-8" /></div>
          <div>
            <h2 className="font-heading font-bold text-2xl">{org.name}</h2>
            <p className="text-white/60 text-sm">Currency: {org.currency} · {org.default_language?.toUpperCase()}</p>
          </div>
        </div>
        <div className="divide-y divide-border">
          {rows.map((r) => (
            <div key={r.label} className="flex items-center gap-3 px-6 py-4">
              <r.icon className="h-4 w-4 text-muted-foreground" />
              <span className="text-sm text-muted-foreground w-32">{r.label}</span>
              <span className="text-sm font-medium">{r.value}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
